import React, { useState } from "react";
import { AccordionProps } from "./types";
import { useStyles } from "./style";
import classNames from "classnames";
import up from '../../images/arrow-up.svg'
import down from '../../images/arrow-down.svg'

export const Accordion = (props: AccordionProps) => {
  const [state, setState] = useState(props.switcher);
  const classes = useStyles();
  return (
    <div className={classNames(classes.accordionItem, props.class)}>
      <div
          className={classes.accordionTitleWrapper}
          onClick={() => {
              setState(!state);
          }}
      >
        <div className={classes.accordionTitle}>{props.title}</div>
        <button
          aria-label="Accordion Switcher"
          className={classes.accordionSwitcher}
        >
          {state ? <img src={down} alt=""/> : <img src={up} alt=""/>}
        </button>
      </div>
      <div
        className={classes.accordionBody}
        style={{ display: state ? "block" : "none" }}
      >
        {props.body}
      </div>
    </div>
  );
};
